import { injectable } from 'inversify';
import { IEventBus } from '@swoft/core';

/**
 * Simple in-memory event bus implementation for DDD package.
 * This provides a temporary solution until proper event infrastructure is implemented.
 */
@injectable()
export class InMemoryEventBus implements IEventBus {
  private handlers: Map<string, Array<(event: any) => Promise<void>>> = new Map();

  async publish(event: any): Promise<void> {
    const eventType = event.eventType || event.constructor.name;
    const eventHandlers = this.handlers.get(eventType) || [];
    
    // Execute all handlers for this event type
    await Promise.all(
      eventHandlers.map(handler => handler(event))
    );
  }

  async publishAll(events: any[]): Promise<void> {
    for (const event of events) {
      await this.publish(event);
    }
  }

  subscribe<TEvent extends any>(
    eventType: string,
    handler: { handle(event: TEvent): Promise<void> }
  ): void {
    const handlers = this.handlers.get(eventType) || [];
    handlers.push((event) => handler.handle(event));
    this.handlers.set(eventType, handlers);
  }
}